import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';
import { UserEntity } from './userApi';

export interface UserState {
  currentUser?: UserEntity;
  accessToken?: string;
}

const initialState: UserState = {};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserEntity>) => {
      state.currentUser = action.payload;
    },
    setAccessToken: (state, action: PayloadAction<string>) => {
      state.accessToken = action.payload;
    },
    logoutUser: () => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUser, logoutUser, setAccessToken } = userSlice.actions;

export const selectUser = (state: RootState) => state.user.currentUser;
export const isLoggedIn = (state: RootState) => !!state.user.accessToken;
export const selectAccessToken = (state: RootState) => state.user.accessToken;

export default userSlice.reducer;
